import { DOMAIN_REGEX } from '@/lib/constants/validation';
import * as yup from 'yup';

export const storeCreationSchema = yup.object({
  name: yup.string().required('Store name is required'),
  domain: yup
    .string()
    .required('Domain name is required')
    .matches(
      DOMAIN_REGEX,
      'Domain names can only contain letters, numbers, and hyphens'
    ),
  industry: yup.string().required('Industry is required'),
  description: yup.string().required('Store description is required'),
  refundPolicy: yup.string(),
  instagram: yup.string(),
  whatsapp: yup.string(),
  tiktok: yup.string(),
});

export type StoreCreationFormData = yup.InferType<typeof storeCreationSchema>;
